
import React from 'react';
import classNames from 'classnames';
import Section from 'components/form/section/section';
import styles from './builder.module.scss';
import { Formik, Field } from 'formik';
import Error from '../../form/builder/error';
import { FormGroup } from 'reactstrap';
import * as Yup from "yup";

const initialValues = {
  PrivacyPolicyAgreement: false
};

const validationSchema = Yup.object({
  PrivacyPolicyAgreement: Yup.boolean()
    .oneOf([true], 'You must accept the terms and conditions')
    .required('You must accept the terms and conditions'),
});

function NavBottom(props) {
  return (
    <Section key={'submitButton'}>
      {props.setStep ?
        props.step === 1 ?
          (
            <>
              <div className="d-flex justify-content-center my-4">
                <button
                  type="submit"
                  disabled={props.isSubmitting || props.isSubmitButtonDisabled}
                  className={classNames('btn', styles['button-custom'])}>
                  Let's Go!
                  {
                    props.loading ?
                      <i className="fas fa-spinner fa-spin ml-3"></i> :
                      ''
                  }
                </button>
              </div>
             

            </>
          ) :
          (
            <div className={'mt-3 mb-4 ' + styles['nav-buttons']}>
              {props.step === 5 && props.setStep ? (
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                >
                  {({
                    errors,
                    touched,
                    setFieldValue
                  }) => {
                    return (
                      <>
                        <FormGroup>
                          {/* <Label for="PrivacyPolicyAgreement">Privacy Policy Agreement</Label> */}
                          <div className="agreement-container container-fluid mt-3">
                            <section className="row">
                              <div className="col-1 mr-0">
                                <Field
                                  style={{ float: 'right', width: "24px", height: "24px" }}
                                  type="checkbox"
                                  name="PrivacyPolicyAgreement"
                                  onChange={e => {
                                    setFieldValue('PrivacyPolicyAgreement', e.target.checked);
                                  }}
                                  validate={value => {
                                    let error;
                                    if (!value) {
                                      error =
                                        'You must accept the privacy policy to continue.';
                                    }
                                    return error;
                                  }}
                                />
                              </div>
                              <div className={`col-11 ml-0 pl-0 ${styles.termsAndDescriptionText}`}>
                                I understand that by checking this box and
                                voluntarily submitting my contact information, I
                                may receive company communications from
                                BTIS/Amynta to provide me access to company
                                information and/or to respond to my requests.
                                For more information, review our{' '}
                                <a
                                  className={classNames(styles.step6Link)}
                                  target={'_blank'}
                                  rel="noopener noreferrer"
                                  href="https://www.amyntagroup.com/privacy-policy/"
                                >
                                  privacy policy
                                </a>
                              </div>
                            </section>
                            <section className="row">
                              <div className="col mt-2">
                                {/* Display error, if any */}
                                {errors.PrivacyPolicyAgreement &&
                                  touched.PrivacyPolicyAgreement && (
                                    <Error>
                                      {errors.PrivacyPolicyAgreement}
                                    </Error>
                                  )}
                              </div>
                            </section>
                          </div>
                        </FormGroup>
                      </>
                    );
                  }}



                </Formik>
              ) : null}
              {props.step && props.setStep ? (
                <button
                  className={classNames(styles['back-button'] ,'btn btn-nav btn-back mb-3 mr-3')}
                  type="button"
                  onClick={e => {
                    if (props.step > 0) {
                      props.setStep(props.step - 1);
                    } else {
                      // Add link to go back to homepage
                      document.location = window.environmentConfig['MAIN_SITE_URL'];
                    }
                  }}
                >
                  {props.step === 1 ? 'Back to Homepage' : 'Back'}
                </button>
              ) : null}

              {props.step === 5 ? (
                <input
                  type="submit"
                  disabled={props.isSubmitting}
                  className={classNames(styles['submitButton'],'btn btn-nav btn-secondary mb-3')}
                  value="Submit"
                />
              ) : (
                <input
                  type="submit"
                  disabled={props.isSubmitting}
                  className={classNames(styles['savebutton'],'btn btn-nav btn-secondary mb-3')}
                  value="Save &amp; Continue"
                />
              )
              }

            </div>
          )
        :
        null}

    </Section>
  );
}

export default NavBottom;